import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export function modalInit(){
  $('[data-modal-trigger]').on('click', function(event){
    event.preventDefault()
    let modalId = $(this).data('modal-trigger')
    let modal = $('[data-modal='+ modalId)

    if(modal){
        $(modal).addClass('modal--visible');
        let content = $(modal).find('.modal__content')
        if(content.length)
          disableBodyScroll(content[0])
    }
  })

  $('[data-modal]').on('click', function(event){
    if(event.target == this || $(event.target).hasClass('icon-close')){
        $('.modal--visible').removeClass('modal--visible')
        clearAllBodyScrollLocks()
    }
  })
}